import React, { Component } from "react";

export default class DetectTouch extends Component {
	
  	
  	componentDidMount() {
	  	if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
	  		if (matchMedia('(pointer:fine)').matches) {
	  			document.getElementsByTagName( 'html' )[0].classList.add('state-no-touch');
	  		} else {
		  		document.getElementsByTagName( 'html' )[0].classList.add('state-touch');
		  	}
	  	} else {
		  	document.getElementsByTagName( 'html' )[0].classList.add('state-no-touch');
	  	}

  	}
  	
  	render () {
	  	
  		return <div></div>;
	
	}
}  